module.exports = __webpack_public_path__ + "static/divas1-255d450b10ef8e27fe6f83462b88f7fe.jpg";